module.exports = __webpack_public_path__ + "img/12-Forces-&-talents.883a9902.png";